function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HistoryTemplate = require('./history.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var SaitoLoader = require('./../../saito-loader/saito-loader');

/**************
 *
 * Deprecated *
 *
 **************/
var MixinHistory = /*#__PURE__*/function () {
  function MixinHistory(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, MixinHistory);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.history_data = null;
    this.loader = new SaitoLoader(this.app, this.mod, '#saito-history-loader');
    this.app.connection.on('saito-crypto-history-render-request', function () {
      _this.render();
    });
  }
  return _createClass(MixinHistory, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _window$navigator,
          _window$navigator2,
          _this2 = this;
        var this_history, balance, locale, decimals, nf, tmp_user_data, tmp_identicon, tmp_identifer;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this_history = this;
              this.mod = this.app.wallet.returnPreferredCrypto();
              this.overlay.show(HistoryTemplate(this.app, this.mod, this));
              balance = Number(this.mod.balance);
              this.loader.show();
              document.querySelector('.mixin-txn-his-container .saito-table-body').innerHTML = '';
              locale = (_window$navigator = window.navigator) !== null && _window$navigator !== void 0 && _window$navigator.language ? (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.language : 'en-US';
              decimals = typeof this.mod.decimals != 'undefined' ? this.mod.decimals : 8;
              nf = new Intl.NumberFormat(locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: decimals
              });
              tmp_user_data = {};
              tmp_identicon = {};
              tmp_identifer = {};
              _context2.n = 1;
              return this.mod.returnHistory(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(html) {
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        if (html != '') {
                          document.querySelector('.mixin-txn-his-container .saito-table-body').innerHTML = html;
                        } else {
                          document.querySelector('.mixin-txn-his-container .saito-table-body').innerHTML = "<p class=\"mixin-no-history\">No account history found for ".concat(_this2.mod.ticker, "</p>");
                          document.querySelectorAll('.pagination-button').forEach(function (btn, key) {
                            btn.classList.add('disabled');
                          });
                        }
                      case 1:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              this.loader.remove();
              this.attachEvents();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      document.querySelectorAll('.history-copy-address').forEach(function (icon) {
        icon.onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            var public_key;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  public_key = e.target.getAttribute('data-address');
                  _context3.n = 1;
                  return navigator.clipboard.writeText(public_key);
                case 1:
                  e.target.classList.toggle('fa-copy');
                  e.target.classList.toggle('fa-check');
                  setTimeout(function () {
                    e.target.classList.toggle('fa-copy');
                    e.target.classList.toggle('fa-check');
                  }, 800);
                case 2:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      });
      var paginationNumbers = document.getElementById('pagination-numbers');
      var listItems = document.querySelectorAll('.mixin-txn-his-container .saito-table-row');
      var nextButton = document.getElementById('next-button');
      var prevButton = document.getElementById('prev-button');
      var paginationLimit = 10;
      var pageCount = Math.ceil(listItems.length / paginationLimit);
      var currentPage = 1;
      if (listItems.length == 0) {
        document.querySelector('.pagination-container').classList.add('disabled');
      }
      var disableButton = function disableButton(button) {
        button.classList.add('disabled');
        //button.setAttribute("disabled", true);
      };
      var enableButton = function enableButton(button) {
        button.classList.remove('disabled');
        //button.removeAttribute("disabled");
      };
      var handlePageButtonsStatus = function handlePageButtonsStatus() {
        if (currentPage === 1) {
          disableButton(prevButton);
        } else {
          enableButton(prevButton);
        }
        if (pageCount === currentPage) {
          disableButton(nextButton);
        } else {
          enableButton(nextButton);
        }
      };
      var handleActivePageNumber = function handleActivePageNumber() {
        document.querySelectorAll('.pagination-number').forEach(function (button) {
          button.classList.remove('active');
          var pageIndex = Number(button.getAttribute('page-index'));
          if (pageIndex == currentPage) {
            button.classList.add('active');
          }
        });
      };
      var appendPageNumber = function appendPageNumber(index) {
        var pageNumber = document.createElement('div');
        pageNumber.className = 'pagination-number';
        pageNumber.innerHTML = index;
        pageNumber.setAttribute('page-index', index);
        pageNumber.setAttribute('aria-label', 'Page ' + index);
        paginationNumbers.appendChild(pageNumber);
      };
      var getPaginationNumbers = function getPaginationNumbers() {
        for (var i = 1; i <= pageCount; i++) {
          appendPageNumber(i);
        }
      };
      var setCurrentPage = function setCurrentPage(pageNum) {
        currentPage = pageNum;
        handleActivePageNumber();
        handlePageButtonsStatus();
        var prevRange = (pageNum - 1) * paginationLimit;
        var currRange = pageNum * paginationLimit;
        listItems.forEach(function (item, index) {
          item.classList.add('hidden');
          if (index >= prevRange && index < currRange) {
            item.classList.remove('hidden');
          }
        });
      };
      getPaginationNumbers();
      setCurrentPage(1);
      prevButton.addEventListener('click', function () {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      });
      nextButton.addEventListener('click', function () {
        if (currentPage < pageCount) {
          setCurrentPage(currentPage + 1);
        }
      });
      document.querySelectorAll('.pagination-number').forEach(function (button) {
        var pageIndex = Number(button.getAttribute('page-index'));
        if (pageIndex) {
          button.addEventListener('click', function () {
            setCurrentPage(pageIndex);
          });
        }
      });
      if (this.mod.ticker == 'SAITO') {
        document.querySelector('.pagination-container').style.display = 'none';
      }
    }
  }]);
}();
module.exports = MixinHistory;